import { styled } from '@clickcease/cc-client-components-lib'

export const GoogleTagManagerModalStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  minHeight: '200px',
})

export const GoogleTagManagerDesc = styled('div', {
  fontSize: '$md',
  fontWeight: '$r',
})

export const GoogleTagManagerModalSelectWrapper = styled('div', {
  marginTop: '$8',
})

export const GoogleTagManagerError = styled('div', {
  color: '$error',
  fontSize: '$md',
  margin: '$2 0',
})

export const ToasterWrapper = styled('div', {
  marginTop: '$12',
})
